export const environment = {
    production: false,
    apiUrl: 'https://demoapi.techo2.com/api/v1/',
};
